import { NotificationWsUrl } from '../config.json';
import { closeWin, fetchConnectPlatformData } from '../store/ConnectPlatform/connectPlatform';

const RECONNECT_INTERVAL = 5000; // 5 seconds
const RECONNECT_DURATION = 300000; // 5 minutes
export const SocketMessageType = {
    CONNECT_MESSAGE: 'CONNECT_MESSAGE',
    FETCH_CONNECTED_PLATFORM: 'FETCH_CONNECTED_PLATFORM',
};

export default class WebSocketManager {
    /**
     * @type {boolean}
     * @description Indicates whether the WebSocket is connected.
     */
    isConnected = false;
    /**
     * @type {WebSocket|null}
     * @description The WebSocket instance, which can be null or a WebSocket object.
     */
    ws = null;
    /**
     * @type {number|null}
     * @description The date and time in timestamp in ms to reconnect the WebSocket.
     */
    reconnectStartTime = null;
    /**
     * @type {boolean}
     * @description Indicates whether the WebSocket is intended to close.
     */
    isIntendedClose = false;
    /**
     * @type {Function|null}
     * @description Indicates whether the WebSocket is intended to close.
     */ dispatch = null;
    /**
     * @type {number|null}
     * @description User Id.
     */ userId = null;

    constructor(dispatch, userId) {
        this.connect();
        this.dispatch = dispatch;
        this.userId = userId;
    }

    // ====== connection method ======
    connect(randomDelay = 0) {
        if (this.ws && [WebSocket.OPEN, WebSocket.CONNECTING].includes(this.ws.readyState)) {
            console.log(`WebSocket is ${this.ws.readyState === WebSocket.OPEN ? 'connected' : 'connecting'}.`);
            return;
        }

        console.log('Connecting to WebSocket...');
        this.ws = new WebSocket(NotificationWsUrl);

        this.ws.onopen = () => {
            this.isConnected = true;
            console.log('WebSocket connected successfully.');
            this.reconnectStartTime = null;
        };

        this.ws.onmessage = (msg) => {
            const data = JSON.parse(msg.data);
            if (data.type && data.message) {
                switch (data.type) {
                    // only add cases for specific handling
                    case SocketMessageType.FETCH_CONNECTED_PLATFORM:
                        this.dispatch(fetchConnectPlatformData());
                        this.dispatch(closeWin());
                        break;
                    default:
                        break;
                }
            }
        };
        this.ws.onerror = (e) => {
            console.error('WebSocket error:', e);
            this.isConnected = false;
            this.reconnect();
        };
        this.ws.onclose = () => {
            this.isConnected = false;
            this.ws = null;
            console.log('WebSocket connection closed.');
            if (this.isIntendedClose) return;
            this.reconnect();
        };
    }

    reconnect() {
        if (!this.reconnectStartTime) {
            this.reconnectStartTime = Date.now();
        }

        const elapsedTime = Date.now() - this.reconnectStartTime;

        const randomDelay = Math.floor(Math.random() * 5000); // Random delay between 0 and 5000 milliseconds

        if (elapsedTime < RECONNECT_DURATION) {
            setTimeout(() => {
                console.log('Attempting to reconnect...');
                if (this.isConnected) return;
                this.connect(randomDelay);
            }, RECONNECT_INTERVAL);
        } else {
            console.error('WebSocket reconnect failed after 5 mins retry attempts.');
        }
    }

    isConnectionReady() {
        if (!this.ws) {
            console.error('ws not ready');
            return false;
        }
        return this.ws.readyState === WebSocket.OPEN;
    }

    closeConnection(isIntendedClose = false) {
        if (this.ws) {
            console.log('Closing WebSocket connection...');
            this.ws.close();
            this.ws = null;
            this.isConnected = false;
            this.isIntendedClose = isIntendedClose;
            this.dispatch = null;
        }
    }

    connectUser(userId) {
        if (this.ws.readyState === WebSocket.OPEN) {
            const msg = {
                type: SocketMessageType.CONNECT_MESSAGE,
                data: { userId: userId },
            };
            this.ws.send(JSON.stringify(msg));
        }
    }

    // ====== operation method ======

    // will parse data to JSON then send to server
    sendMessage(msg) {
        if (!this.ws.readyState === WebSocket.OPEN) {
            console.error('connection error');
            return;
        }
        this.ws.send(JSON.stringify(msg));
    }
}
